import { Navigate, Outlet } from 'react-router-dom';
import { useUserAuth } from '../hooks/useUserAuth';

/**
 * Rota protegida: exige uma sessão local válida e não expirada.
 * Caso contrário, redireciona para /tec_pec (início do fluxo de login/cadastro).
 */
function ProtectedRoute() {

  const { getLocalSession } = useUserAuth();
  const hasSession = getLocalSession() !== null;

  if (!hasSession) {
    return <Navigate to="/tec_pec" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
